import React, { useState, useEffect } from "react";
import { } from "react-router";

import "bootstrap/dist/css/bootstrap.min.css";
//import logo from "./logo_clean_verify.png"
import "../../../App.css";

import AuthService from "../../../services/auth.service";


import { useAuth } from "../../../context/AuthContext";


import NavBottom from "./NavBottom";
import Header from "./Header";
import Footer from "./Footer";




//const user = AuthService.getCurrentUser();


//import AuthVerify from "./common/AuthVerify";
//import EventBus from "./common/EventBus";

const Template = ({children}) => {

      const { user } = useAuth();
  //const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  //const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  

  useEffect(() => {
    
    

    if (user) {
      setCurrentUser(user);
      setIsLoggedIn(true);
    //  setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
    //  setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

    /*
    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
    */
  }, [user]);

 

  return (
    
  <div className="lg:container  mx-auto ">

    <Header />
    
    <div id="main" className="  p-4 md:p-12 lg:p-18 mb-20">
      {children}
    </div>

    <NavBottom />
    <Footer />
    
  </div>
    
     
  );
};

export default Template;
